import axios from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import {
  SavedFilterTypes,
  UserSavedFiltersResponse,
} from 'src/models/userSavedFilters.models'
import { RootState } from 'src/redux/createRootReducer'
import { selectAuthedFormApiRequestConfig } from 'src/redux/selectors/axios.selectors'
import { BackendErrorPayload } from 'src/utils/error.utils'

export const GET_USER_SAVED_FILTERS_INIT =
  'data/userSavedFilters/GET_USER_SAVED_FILTERS_INIT'
export const GET_USER_SAVED_FILTERS_SUCCESS =
  'data/userSavedFilters/GET_USER_SAVED_FILTERS_SUCCESS'
export const GET_USER_SAVED_FILTERS_FAILURE =
  'data/userSavedFilters/GET_USER_SAVED_FILTERS_FAILURE'

export type GetUserSavedFiltersSuccessPayload = {
  savedFilters: UserSavedFiltersResponse[]
}

export type GetUserSavedFiltersFailurePayload = BackendErrorPayload<string>

export interface GetUserSavedFiltersInitAction {
  type: typeof GET_USER_SAVED_FILTERS_INIT
}

export interface GetUserSavedFiltersSuccessAction {
  type: typeof GET_USER_SAVED_FILTERS_SUCCESS
  payload: GetUserSavedFiltersSuccessPayload
}

export interface GetUserSavedFiltersFailureAction {
  type: typeof GET_USER_SAVED_FILTERS_FAILURE
  payload: GetUserSavedFiltersFailurePayload
}

export type GetUserSavedFiltersActions =
  | GetUserSavedFiltersInitAction
  | GetUserSavedFiltersSuccessAction
  | GetUserSavedFiltersFailureAction

const createGetUserSavedFiltersInitAction =
  (): GetUserSavedFiltersInitAction => ({
    type: GET_USER_SAVED_FILTERS_INIT,
  })

const createGetUserSavedFiltersSuccessAction = (
  payload: GetUserSavedFiltersSuccessPayload,
): GetUserSavedFiltersSuccessAction => ({
  type: GET_USER_SAVED_FILTERS_SUCCESS,
  payload,
})

const createGetUserSavedFiltersFailureAction = (
  err: GetUserSavedFiltersFailurePayload,
): GetUserSavedFiltersFailureAction => ({
  type: GET_USER_SAVED_FILTERS_FAILURE,
  payload: err,
})

export const getUserSavedFilters = (
  filterType: SavedFilterTypes,
): ThunkAction<Promise<void>, RootState, void, GetUserSavedFiltersActions> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, GetUserSavedFiltersActions>,
    getState: () => RootState,
  ): Promise<void> => {
    dispatch(createGetUserSavedFiltersInitAction())
    return axios
      .get(
        `/usersavedfilters/${filterType}`,
        selectAuthedFormApiRequestConfig(getState()),
      )
      .then(
        (response) => {
          dispatch(createGetUserSavedFiltersSuccessAction(response.data))
        },
        (err) => {
          dispatch(
            createGetUserSavedFiltersFailureAction(
              err.response?.data || err.message,
            ),
          )
        },
      )
  }
}
